import { render } from "./headerCom3.vue?vue&type=template&id=7f6ebb3b&scoped=true"
const script = {}

import "./headerCom3.vue?vue&type=style&index=0&id=7f6ebb3b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f6ebb3b"]])

export default __exports__